// extracted by mini-css-extract-plugin
export default {"BoxLoading":"BoxLoading_BoxLoading__T7cA7"};